import DefaultViewPiehart from "../defaulViewPieChartMini";
import DefaultViewChartMiniLine from "../defaultViewLineChartMini";
import DefaultViewChartMiniBar from "../defaultViewBarChartMini";
import NotFoundPage from "../../Components/notFound/NotFoundPage";




const MiniBox = () => {
    const data = {
        "idTipoGraficoProps": 363,
        "nameTitleProps": "Aprobación presidencial - Gabriel Boric",
        "tituloProps": "Aprobación presidencial - Gabriel Boric",
        "selectValueProsp": [
            {
                "label": "Aprueba",
                "value": "Aprueba"
            },
            {
                "label": "Desaprueba",
                "value": "Desaprueba"
            },
            {
                "label": "No aprueba, ni desaprueba",
                "value": "No aprueba, ni desaprueba"
            },
            {
                "label": "No sabe, no responde",
                "value": "No sabe, no responde"
            }
        ],
        "subtitleProps": " ¿Usted aprueba o desaprueba la forma como Gabriel Boric está conduciendo su gobierno? %",
        "disableFilterProps": true,
        "formatDataStringData": "%",
        "numDecimalProps": 0,
        "pieTextProps": "Semana 1, Enero, 2025. Fuente: Plaza Pública. ",
        "showPieTextInGraph": true
    }
    const dataLineal = {
        "idTipoGraficoProps": 361,
        "nameTitleProps": "Evolución IPSA mensual",
        "tituloProps": "Evolución IPSA mensual",
        "selectValueProsp": [
            {
                "label": "En puntos",
                "value": "En puntos"
            }
        ],
        "subtitleProps": "Banco Central. El Índice se muestra en puntos.",
        "disableFilterProps": true,
        "formatDataStringData": "",
        "numDecimalProps": 1,
        "pieTextProps": "",
        "showPieTextInGraph": true,
        "showSeries": true,
        "mostrarlegend": false,
        "isRevertGraphY": false,
        "isThousandFormat": false
    }

    const dataBar ={
        "idTipoGraficoProps": 364,
        "nameTitleProps": "Ánimo actual",
        "tituloProps": "Ánimo actual",
        "selectValueProsp": [
            {
                "label": "23 Diciembre 2024",
                "value": "23 Diciembre 2024"
            }
        ],
        "subtitleProps": "¿Cómo calificarías tu estado de ánimo actual? | ¿Cómo calificarías tu nivel de estrés? % 6 + 7",
        "disableFilterProps": true,
        "formatDataStringData": "%",
        "numDecimalProps": 0,
        "pieTextProps": "Semana 4, Diciembre, 2024. Fuente: Estudio 5C.",
        "titleY": "",
        "showPieTextInGraph": true,
        "mostrarNegativos": false,
        "mostrarlegend": false
    }


    return (
        <div className="">

            <div className="d-flex mb-2 justify-content-center" style={{height:350, width:350, backgroundColor:'red',justifyContent:'center', alignItems:'center'}}>
                <NotFoundPage />
                </div>

      
                <div className="d-flex mb-2 " style={{height:350, width:350, backgroundColor:'red',justifyContent:'center', alignItems:'center'}}>
            <DefaultViewChartMiniLine idTipoGraficoProps={dataLineal.idTipoGraficoProps} nameTitleProps={dataLineal.nameTitleProps} tituloProps={dataLineal.tituloProps} selectValueProsp={dataLineal.selectValueProsp} subtitleProps={dataLineal.subtitleProps}  disableFilterProps={dataLineal.disableFilterProps} formatDataStringData={dataLineal.formatDataStringData} numDecimalProps={dataLineal.numDecimalProps} pieTextProps={dataLineal.pieTextProps}  showPieTextInGraph={dataLineal.showPieTextInGraph} />        
                </div>
                <div className="d-flex " style={{height:350, width:350, backgroundColor:'red',justifyContent:'center', alignItems:'center'}}>
            <DefaultViewChartMiniBar idTipoGraficoProps={dataBar.idTipoGraficoProps} nameTitleProps={dataBar.nameTitleProps} tituloProps={dataBar.tituloProps} selectValueProsp={dataBar.selectValueProsp} subtitleProps={dataBar.subtitleProps}  disableFilterProps={dataBar.disableFilterProps} formatDataStringData={dataBar.formatDataStringData} numDecimalProps={dataBar.numDecimalProps} pieTextProps={dataBar.pieTextProps}  showPieTextInGraph={dataBar.showPieTextInGraph} />        
                </div>
          
        </div>
    )
}

export default MiniBox